(function () {

function $f6132dc5fa83627f$export$315c4345ad85e611(root = document) {
    const { Swiper: Swiper, SwiperModules: SwiperModules = {} } = window.fbsThemeVendors || {};
    if (!Swiper || document.body.classList.contains('block-editor-page')) return;
    root.querySelectorAll('[data-projects-showcase]').forEach((block)=>{
        if (block.dataset.ready) return;
        const buttons = [
            ...block.querySelectorAll('[data-project-choice]')
        ];
        const count = buttons.length;
        if (!count) return;
        block.dataset.ready = 'true';
        buttons.forEach((button)=>{
            button.disabled = false;
        });
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const speed = reduced ? 0 : Number(block.dataset.speed) || 800;
        const initial = Math.min(count - 1, Number(block.dataset.initial) || 0);
        block.style.setProperty('--project-speed', `${speed}ms`);
        let current = initial;
        let announcement;
        const update = (index, announce = false)=>{
            current = index;
            buttons.forEach((button, i)=>{
                let offset = (i - index + count) % count;
                if (offset > Math.floor(count / 2)) offset -= count;
                const row = button.parentElement;
                const visible = Math.abs(offset) <= 2;
                row.hidden = !visible;
                const previous = Number(row.style.getPropertyValue('--offset'));
                // Re-enter at the outer edge instead of sweeping a wrapped name
                // through the selected project in the middle of the list.
                if (count > 3 && Math.abs(offset - previous) > count / 2) {
                    row.style.transition = 'none';
                    row.style.setProperty('--offset', offset + Math.sign(offset));
                    row.style.setProperty('--opacity', '0');
                    row.getBoundingClientRect();
                    row.style.transition = '';
                }
                row.style.setProperty('--offset', offset);
                row.style.setProperty('--adjust', Math.sign(offset) * (Math.abs(offset) === 1 ? 3 : -3));
                row.style.setProperty('--weight', offset < 0 ? 400 : offset === 0 ? 500 : 300);
                row.style.setProperty('--opacity', offset === 0 ? '.8' : offset < 0 ? '.75' : offset === 1 ? '.45' : '.3');
                button.setAttribute('aria-pressed', String(i === index));
            });
            block.querySelectorAll('.swiper-slide').forEach((slide)=>{
                var _slide_dataset_swiperSlideIndex;
                const active = Number((_slide_dataset_swiperSlideIndex = slide.dataset.swiperSlideIndex) !== null && _slide_dataset_swiperSlideIndex !== void 0 ? _slide_dataset_swiperSlideIndex : [
                    ...slide.parentElement.children
                ].indexOf(slide)) === index;
                slide.setAttribute('aria-hidden', String(!active));
                slide.querySelector('a').tabIndex = active ? 0 : -1;
            });
            if (announce) {
                clearTimeout(announcement);
                announcement = setTimeout(()=>{
                    block.querySelector('[data-project-status]').textContent = buttons[index].textContent;
                }, speed + 50);
            }
        };
        block.classList.add('is-ready', 'is-initializing');
        const slider = new Swiper(block.querySelector('[data-project-photos]'), {
            modules: [
                SwiperModules.A11y
            ].filter(Boolean),
            initialSlide: initial,
            speed: speed,
            loop: count > 1,
            allowTouchMove: count > 1,
            simulateTouch: true,
            threshold: 8,
            preventClicks: true,
            preventClicksPropagation: true,
            slidesPerView: 1,
            spaceBetween: 8,
            watchOverflow: true,
            a11y: {
                enabled: true,
                containerMessage: 'Project photographs'
            },
            on: {
                init (instance) {
                    update(instance.realIndex);
                },
                slideChange (instance) {
                    update(instance.realIndex, true);
                }
            }
        });
        const select = (index)=>{
            if (count < 2) return;
            const next = (index + count) % count;
            update(next, true);
            slider.slideToLoop(next);
        };
        buttons.forEach((button, index)=>button.addEventListener('click', ()=>select(index)));
        const selector = block.querySelector('[data-project-selector]');
        selector.addEventListener('keydown', (event)=>{
            const delta = [
                'ArrowDown',
                'ArrowRight'
            ].includes(event.key) ? 1 : [
                'ArrowUp',
                'ArrowLeft'
            ].includes(event.key) ? -1 : 0;
            if (!delta && ![
                'Home',
                'End'
            ].includes(event.key)) return;
            event.preventDefault();
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? count - 1 : (current + delta + count) % count;
            select(next);
            buttons[next].focus({
                preventScroll: true
            });
        });
        update(initial);
        requestAnimationFrame(()=>requestAnimationFrame(()=>block.classList.remove('is-initializing')));
    });
}


const $8f02dc1551dee702$var$runBlock = ()=>(0, $f6132dc5fa83627f$export$315c4345ad85e611)(document);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $8f02dc1551dee702$var$runBlock, {
    once: true
});
else $8f02dc1551dee702$var$runBlock();

})();
//# sourceMappingURL=projects-showcase.js.map
